import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import "./Main.css";
import "./Home.css";
import TopNav from "./TopNav";
import MainNav from "./MainNav";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";
import LoginFail from "../util/LoginFail";
import HomeCard from "../util/HomeCard";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectCenter from "../util/SelectCenter";
import Moment from "react-moment";
import { subDays } from "date-fns";
import { format } from "date-fns";
import ko from "date-fns/locale/ko";
import pr from "../lib/pr.js";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import { loginState, configState } from "../lib/State";
import Layout from "./Layout";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import CenterSelect from "./CenterSelect";
import { Box, Divider } from "@mui/material";
import ChartClassToday from "./ChartClassToday";
import ChartClassWeekly from "./ChartClassWeekly";
import ChartClassMonthly from "./ChartClassMonthly";
import Grid from '@mui/material/Grid';
import ChartSaleToday from "./ChartSaleToday";
import ChartSaleMonthly from "./ChartSaleMonthly";
import ChartSaleWeekly from "./ChartSaleWeekly";
// import HomeChartReservation from "./HomeChartReservation";
// import HomeChartHrPoint from "./HomeChartHrPoint";
// import HomeChartCash from "./HomeChartCash";

export default function Home() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [tcid, setTcid] = useState('');

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  return (
    <Layout login={login}>
      <Box>
        <Box sx={{ mt: 1 }}>
          <CenterSelect
            login={login}
            tcidParent={tcid}
            setTcidParent={setTcid}
          />
        </Box>

        <Box>
          <Grid container>
            <Grid xs={4}>
              {/* 오늘예약 */}
              <Box fontSize={17} marginTop={3} marginLeft={2}>일간 수업</Box>
              <ChartClassToday tcidParent={tcid}>
              </ChartClassToday>
            </Grid>
            <Grid xs={4}>
              {/* 주간예약 */}
              <Box fontSize={17} marginTop={3} marginLeft={2}>주간 수업</Box>
              <ChartClassWeekly tcidParent={tcid}>
              </ChartClassWeekly>
            </Grid>
            <Grid xs={4}>
              {/* 월간예약 */}
              <Box fontSize={17} marginTop={3} marginLeft={2}>월간 수업</Box>
              <ChartClassMonthly tcidParent={tcid}>
              </ChartClassMonthly>
            </Grid>
          </Grid>
        </Box>

        <Divider></Divider>
        
        {<Box>
          <Grid container>
            <Grid xs={4}>
              <Box fontSize={17} marginTop={3} marginLeft={2}>일간 매출</Box>
              <ChartSaleToday tcidParent={tcid}>
              </ChartSaleToday>
            </Grid>
            <Grid xs={4}>
              <Box fontSize={17} marginTop={3} marginLeft={2}>주간 매출</Box>
              <ChartSaleWeekly tcidParent={tcid}>
              </ChartSaleWeekly>
            </Grid>
            <Grid xs={4}>
              <Box fontSize={17} marginTop={3} marginLeft={2}>월간 매출</Box>
              <ChartSaleMonthly tcidParent={tcid}>
              </ChartSaleMonthly>
            </Grid>
          </Grid>
        </Box>}

        {/* <Box> 
          <HomeChartReservation tcidParent={tcid}></HomeChartReservation>         
        </Box>

        <Box sx={{ mt:5}}> 
          <HomeChartHrPoint tcidParent={tcid}></HomeChartHrPoint>         
        </Box>   

        <Box sx={{ mt:5}}> 
          <HomeChartCash tcidParent={tcid}></HomeChartCash>         
        </Box>    */}
      </Box>
    </Layout>
  );
}
